// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParallaxContent_wrapper__wmIIY","innerWrapper":"ParallaxContent_innerWrapper__b3Tg0","content":"ParallaxContent_content__FhheZ"};